// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"1a815fc8a8518c09","5285":"43d99b21544f7619"}[chunkId] + ".css";
};